

import { genericStore } from "../../store/genericStore";
import { AlertMessage } from "../models/error.model";
      
export default function showAlert(text: string, type: string, time?: number) {
    try {
        const messageId = crypto.randomUUID();
        const e = new AlertMessage(messageId,text, type);
        genericStore.setAlert(e);
        setTimeout(() => {
            genericStore.deleteAlert(messageId);
        }, time ? time : 5000);   
    } catch (err) {
        console.log(`error saving message alert: ${err}`)
    }
}